import React from 'react';

import {Helmet, useNavigate} from 'views/module';

import CaregiverScheduleDashboard from 'views/scenes/schedule/caregiver/CaregiverScheduleDashboard';
import SCHEDULE_SOURCES from 'views/scenes/schedule/schedule_source';

import FLAGS, {useFlag} from 'utils/feature_flags/flags';

const LoomCaregiverScheduleDashboardPage = () => {
  const scheduleReadFlag = useFlag(FLAGS.SCHEDULE_READS_FROM_LOOM);
  const navigate = useNavigate();

  React.useEffect(() => {
    if (scheduleReadFlag.isLoading || scheduleReadFlag.isEnabled) return;

    navigate('/schedule/caregiver', {replace: true});
  }, [scheduleReadFlag.isEnabled, scheduleReadFlag.isLoading, navigate]);

  if (scheduleReadFlag.isLoading || !scheduleReadFlag.isEnabled) return null;

  return (
    <>
      <Helmet>
        <title>Quilt: Caregiver Schedule (Loom)</title>
      </Helmet>
      <CaregiverScheduleDashboard
        scheduleSource={SCHEDULE_SOURCES.LOOM}
      />
    </>
  );
};

export default LoomCaregiverScheduleDashboardPage;
